// Module
var code = `<input type="{{\$ctrl.getType()}}"
  ng-model="\$ctrl.dateModel"
  ng-disabled="\$ctrl.\$attrs.disabled"
  ng-model-options="{ allowInvalid: true, updateOn: 'default blur' }"
  ng-class="{'nx-empty': !\$ctrl.dateModel}"
  min="{{ \$ctrl.minBoundary }}"
  max="{{ \$ctrl.maxBoundary }}"
  ng-blur="\$ctrl.onBlur()"
  ng-change="\$ctrl.syncNgModel()"/>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/date/date.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;